import React, { useState } from 'react'
import { SharePaymentLink } from './SharePaymentLink'
import { SharableLinkCreator } from './SharableLinkCreator'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'

type SharePaymentProps = {
  shareCode: string
  vendorCode: string
}

export const SharePayment = ({ shareCode, vendorCode }: SharePaymentProps) => {
  const intl = useIntl()
  const [isLinkReady, setIsLinkReady] = useState(false)

  const [message, setMessage] = useState(
    intl.formatMessage({ id: 'socialSharingLinkPaymentContent' })
  )

  return isLinkReady ? (
    <SharePaymentLink shareCode={shareCode} message={message} />
  ) : (
    <SharableLinkCreator
      message={message}
      setMessage={setMessage}
      vendorCode={vendorCode}
      setIsLinkReady={setIsLinkReady}
    />
  )
}
